export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="bg-gradient-to-br from-background-50 via-background-100 to-primary-500/5 rounded-2xl border border-background-200/60 p-8 md:p-10 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/5 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
                <div className="w-1 h-7 bg-primary-500 rounded-full"></div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">移动端入口</h2>
              </div>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-lg">
                随时随地吃瓜不迷路！911黑料网移动端适配手机浏览器，打开即用无需下载。
                关注官方公众号获取推送通知，第一时间掌握最新黑料动态，吃瓜永远快人一步。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <div className="flex items-center gap-3 bg-background-200 rounded-xl px-5 py-3 cursor-pointer hover:bg-background-300 transition-colors">
                  <i className="ri-smartphone-line text-primary-500 text-xl"></i>
                  <div>
                    <div className="text-xs text-foreground-400">手机浏览器访问</div>
                    <div className="text-sm font-semibold text-foreground-800">m.911heiliaowang.com</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-accent-500/10 rounded-xl px-5 py-3 border border-accent-500/20 cursor-pointer hover:bg-accent-500/20 transition-colors">
                  <i className="ri-wechat-line text-accent-500 text-xl"></i>
                  <div>
                    <div className="text-xs text-foreground-400">微信公众号</div>
                    <div className="text-sm font-semibold text-foreground-800">911黑料网</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="shrink-0">
              <div className="relative">
                <div className="w-40 h-72 bg-background-200 rounded-2xl border-2 border-background-300 overflow-hidden shadow-lg">
                  <div className="h-10 bg-primary-500 flex items-center justify-center">
                    <span className="text-[10px] text-background-50 font-bold">911黑料网</span>
                  </div>
                  <div className="p-3 space-y-2">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="h-12 bg-background-300 rounded-lg flex items-center px-2 gap-2">
                        <div className="w-8 h-8 rounded bg-primary-500/20 shrink-0"></div>
                        <div className="flex-1">
                          <div className="h-2 bg-foreground-300 rounded w-3/4 mb-1"></div>
                          <div className="h-1.5 bg-foreground-200 rounded w-1/2"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="absolute -bottom-2 -right-2 w-10 h-10 flex items-center justify-center bg-accent-500 rounded-full">
                  <i className="ri-flashlight-fill text-background-50"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}